import DetailVideo from './DetailVideo'

export default DetailVideo
// eslint-disable-next-line import/export
export * from './DetailVideo'
